<template>
    <date-time-picker
        class="pt-2"
        :date="fetchDate"
        :picker-options="pickerOptions"
        :range-separator="rangeSeparator"
        :clearable="false"
        @on-change="onChange"
    />
</template>
<script>
import { TIME_LINE_TIMESTAMP } from '@/enum/generic'
import { dayjs } from '@/composables/useDayjs'
import get from 'lodash/get'

export default {
    props: {
        model: {
            type: Object,
            default: () => ({})
        },
        widgetTimeOptions: {
            type: Array,
            default: () => []
        },
        rangeSeparator: {
            type: String
        }
    },
    components: {
        DateTimePicker: () => import('../../../Common/DateTimePicker.vue')
    },
    data () {
        return {
            pickerOptions: {
                disabledDate (time) {
                    const date = new Date()
                    const dateAfterNineteenDays = date.setDate(date.getDate() + 90)
                    return time.getTime() > dateAfterNineteenDays
                },
            },
            date: []
        }
    },
    computed: {
        fetchDate () {
            let newDate = new Date()
            const widgetTime = this.model.WidgetTime

            const startDate = newDate.setDate(newDate.getDate() - parseInt(widgetTime.Date_interval))

            newDate = new Date()
            const endDate = newDate.setDate(newDate.getDate() + (-parseInt(widgetTime.Date_interval) + parseInt(widgetTime.datedeff)))

            return [ startDate, endDate ]
        }
    },
    methods: {
        onChange (dates) {
            const dateStart = get(dates, '[0]')
            const dateEnd = get(dates, '[1]')

            const Difference_In_Time = dateEnd.getTime() - dateStart.getTime()

            this.model.WidgetTime.datedeff = parseInt(Difference_In_Time / TIME_LINE_TIMESTAMP.DAY).toString()

            const _Difference_In_Time = new Date().getTime() - dateStart.getTime()
            this.model.WidgetTime.Date_interval = parseInt(_Difference_In_Time / TIME_LINE_TIMESTAMP.DAY).toString()

            this.model.WidgetTime['Date_start'] = dayjs(new Date(dateStart)).format('YYYY-MM-DD')
            this.model.WidgetTime['Date_end'] = dayjs(new Date(dateEnd)).format('YYYY-MM-DD')
        }
    }
}
</script>
